import { render, staticRenderFns } from "./VaccineTemplateDetails.vue?vue&type=template&id=11eab22a&scoped=true"
import script from "./VaccineTemplateDetails.vue?vue&type=script&lang=js"
export * from "./VaccineTemplateDetails.vue?vue&type=script&lang=js"
import style0 from "./VaccineTemplateDetails.vue?vue&type=style&index=0&id=11eab22a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11eab22a",
  null
  
)

export default component.exports